module.exports = __webpack_public_path__ + "static/media/IMG_20191204_130837.df56fb75.jpg";